(() => {
  const properties = ['--dk-title-height', '--dk-review-height', '--dk-price-height'];
  const observed = new WeakMap();
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      align();
    });
  };
  const resize = new ResizeObserver(entries => {
    let changed = false;
    entries.forEach(entry => {
      const width = entry.contentRect.width;
      if (observed.get(entry.target) !== width) {
        observed.set(entry.target, width);
        changed = true;
      }
    });
    if (changed) schedule();
  });
  function align() {
    document.querySelectorAll('.dk-design-update .product-grid').forEach(grid => {
      if (!observed.has(grid)) {
        observed.set(grid, grid.getBoundingClientRect().width);
        resize.observe(grid);
      }
      const cards = Array.from(grid.children).map(item => {
        const card = item.querySelector('.product-card-wrapper');
        const info = card?.querySelector('.card > .card__content > .card__information');
        if (!info || !item.getClientRects().length) return null;
        properties.forEach(property => card.style.removeProperty(property));
        return {
          item, card,
          title: info.querySelector('.card__heading'),
          review: info.querySelector('.jdgm-widget'),
          price: info.querySelector('.price')
        };
      }).filter(card => card && card.title && card.price);
      const rows = [];
      cards.forEach(card => {
        const top = card.item.getBoundingClientRect().top;
        let row = rows.find(candidate => Math.abs(candidate.top - top) < 2);
        if (!row) rows.push(row = { top, cards: [] });
        row.cards.push(card);
      });
      rows.forEach(row => {
        const titles = row.cards.map(card => {
          const anchor = card.review || card.price;
          return {
            card,
            height: card.title.getBoundingClientRect().height,
            offset: anchor.getBoundingClientRect().top - card.item.getBoundingClientRect().top
          };
        });
        const titleBottom = Math.max(...titles.map(title => title.offset));
        titles.forEach(({ card, height, offset }) => {
          card.card.style.setProperty('--dk-title-height', Math.ceil(height + titleBottom - offset) + 'px');
        });
        const reviews = row.cards.map(card => ({
          card,
          height: card.review?.getBoundingClientRect().height || 0,
          offset: card.price.getBoundingClientRect().top - card.item.getBoundingClientRect().top
        }));
        const priceTop = Math.max(...reviews.map(review => review.offset));
        reviews.forEach(({ card, height, offset }) => {
          if (card.review) card.card.style.setProperty('--dk-review-height', Math.ceil(height + priceTop - offset) + 'px');
        });
        const priceHeight = Math.max(...row.cards.map(card => card.price.getBoundingClientRect().height));
        row.cards.forEach(card => card.card.style.setProperty('--dk-price-height', Math.ceil(priceHeight) + 'px'));
      });
    });
  }
  const mutations = new MutationObserver(records => {
    if (records.some(record =>
      record.target instanceof Element && record.target.closest('.product-grid') ||
      Array.from(record.addedNodes).some(node => node instanceof Element && (node.matches('.product-grid') || node.querySelector('.product-grid')))
    )) schedule();
  });
  mutations.observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();
